module.exports = __webpack_public_path__ + "assets/img/等待发货.5b4a5b83.svg";